export enum IconName {
  backArrowSlider = 'back-arrow-slider',
  forwardArrowSlider = 'forward-arrow-slider',
  backArrow = 'back-arrow',
  chat = 'chat',
  check = 'check',
  clipboard = 'clipboard',
  close = 'close',
  facebook = 'facebook',
  forwardArrow = 'forward-arrow',
  instagram = 'instagram',
  menu = 'menu',
  menuSmall = 'menu-small',
  messenger = 'messenger',
  mute = 'mute',
  pause = 'pause',
  playCircle = 'play-circle',
  playCircleOutlined = 'play-circle-outlined',
  play = 'play',
  roundedArrow = 'rounded-arrow',
  share = 'share',
  tiktok = 'tiktok',
  twitch = 'twitch',
  twitter = 'twitter',
  unmute = 'unmute',
  whatsapp = 'whatsapp',
  youtube = 'youtube',
}

export type IconNameType =
  | 'back-arrow-slider'
  | 'forward-arrow-slider'
  | 'back-arrow'
  | 'chat'
  | 'check'
  | 'clipboard'
  | 'close'
  | 'facebook'
  | 'forward-arrow'
  | 'instagram'
  | 'menu'
  | 'menu-small'
  | 'messenger'
  | 'mute'
  | 'pause'
  | 'play-circle'
  | 'play-circle-outlined'
  | 'play'
  | 'rounded-arrow'
  | 'share'
  | 'tiktok'
  | 'twitch'
  | 'twitter'
  | 'unmute'
  | 'whatsapp'
  | 'youtube';

const IconNameValues = Object.values(IconName);

export type IconNameType2 = (typeof IconNameValues)[number];
